import React from "react";
import { styled } from "@mui/system";

const DetailsWrapper = styled("div")(() => ({
  display: "flex",
  padding: "16px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "12px",
  alignSelf: "stretch",
  borderRadius: "8px",
  background: "#F8F9F9",
}));

const DetailsHeader = styled("div")(() => ({
  alignSelf: "stretch",
  color: "#002035",
  fontFamily: "Söhne",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "17px",
}));

const Text = styled("div")(() => ({
  alignSelf: "stretch",
  color: " #002035",
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "14px",
}));

interface GenericTextBlockProps {
  header: string;
  text: string;
}

/**
 * A component to display a generic text block with a header and text.
 * @param {string} props.header - The header of the text block.
 * @param {string} props.text - The main text content of the block.
 */
const GenericTextBlock = (props: GenericTextBlockProps) => {
  const { header, text } = props;
  return (
    <DetailsWrapper>
      <DetailsHeader>{header}</DetailsHeader>
      <Text>{text}</Text>
    </DetailsWrapper>
  );
};

export default GenericTextBlock;
